const map = {
	"./apparel/image1.png": 64658,
	"./bulk-registration-service/image1.png": 65791,
	"./cruise/image1.png": 2318,
	"./daiyu/image1.png": 76099,
	"./hakirei-cms/image1.png": 62634,
	"./iot-camera-system/image1.png": 81917,
	"./kenjaya/image1.png": 60546,
	"./liberty/image1.png": 43820,
	"./line/image1.png": 45175,
	"./n-plus/image1.png": 78356,
	"./payment-service/image1.png": 2167,
	"./realestate/image1.png": 30185,
	"./rss/image1.png": 90011,
	"./shoemaker-web/image1.png": 13289,
	"./shoemaker/image1.png": 44410,
	"./techrise/image1.png": 25647,
	"./token-news/image1.png": 8354,
	"./wwx/image1.png": 12909
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82618;